module.exports = __webpack_public_path__ + "static/media/art25.7066195e.jpg";